const toNull = (value) => {
  const trimmed = typeof value === 'string' ? value.trim() : value;
  return trimmed || null;
};

/**
 * Builds the request body for POST/PUT /insurance/:partnerId/enablement.
 *
 * @param {Object}  args.values      Formik values (modal field ids).
 * @param {boolean} args.exclusive   Whether "only show this provider" is on.
 * @param {boolean} args.hasReferral Whether a referral provider was entered.
 * @param {boolean} args.isUpdate    Whether this is a returning partner (PUT) vs first-time (POST).
 * @return {Object} { exclusive, referralLink?, insuranceDetails? }
 */
export function buildEnablementPayload({ values, exclusive, hasReferral, isUpdate }) {
  const payload = { exclusive: Boolean(exclusive) };

  if (hasReferral) {
    payload.referralLink = {
      label: (values.providerName || '').trim(),
      url: (values.referralUrl || '').trim(),
    };
  }

  // Only a first-time non-exclusive enablement carries the company/legal details:
  // - exclusive skips Beagle, so the backend does not require them;
  // - a returning partner (PUT) already has details on file (updating them is out of
  //   scope here), and re-sending them collides with the backend's "details already
  //   exist" guard, so we omit them.
  if (!exclusive && !isUpdate) {
    payload.insuranceDetails = {
      legalName: values.legalName,
      legalEmail: values.email,
      legalPhone: values.phone,
      street1: values.addressLine1,
      street2: toNull(values.addressLine2),
      city: values.city,
      state: values.state,
      zip: values.zip,
      userFirstName: values.firstName,
      userLastName: values.lastName,
    };
  }

  return payload;
}
